import React from "react";
import Hero from './AerialCinematography/Hero';
import MagicBento from './AerialCinematography/MagicBento';
import CertificationMumbaiChandigarh from "./CertificationMumbaiChandigarh";
import WhoCanApply from "./WhoCanApply";

const Cinematography = () => {

  return (
    <>
      <Hero />
      <WhoCanApply />
      <MagicBento />
      <CertificationMumbaiChandigarh />
    </>
  );
};

export default Cinematography;
